import React, { useState, useEffect } from 'react';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../context/CartContext';

export function CartIcon() {
  const { totalItems } = useCart();
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (totalItems > 0) {
      setIsAnimating(true);
      const timer = setTimeout(() => setIsAnimating(false), 300);
      return () => clearTimeout(timer);
    }
  }, [totalItems]);

  return (
    <div className="relative">
      <ShoppingCart 
        className={`w-6 h-6 transition-transform ${
          isAnimating ? 'scale-125' : 'scale-100'
        }`}
      />
      {totalItems > 0 && (
        <div className={`absolute -top-2 -right-2 bg-yellow-400 text-black 
          rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold
          ${isAnimating ? 'animate-bounce' : ''}`}
        >
          {totalItems}
        </div>
      )}
    </div>
  );
}